/*
 * KRYO — minimal <cart-form> replacing the source's bundle-based cart-form + checkout-upsells-atc.
 * Same DOM hooks as the source: `.checkbox-upsell-button` (ATC, one per variant inside <buy-buttons>),
 * `.chkbox_upsell` checkboxes each inside a `[data-variant-id]` container, `.checkbox-upsell.active` state.
 * Behaviour: add the selected variant + any checked upsells via /cart/add.js, then open Prestige's
 * cart drawer if present, else navigate to /cart.
 */
class KryoCartForm extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('[data-product-card-selected_variant_id]') || document.querySelector('product-card');
    this.querySelectorAll('.checkbox-upsell-button').forEach((b) =>
      b.addEventListener('click', (e) => this.add(e))
    );
    this.upsells = Array.from(document.querySelectorAll('.chkbox_upsell'));
    this.upsells.forEach((cb) => {
      cb.addEventListener('change', () => this.toggle(cb));
      this.toggle(cb);
    });
  }
  toggle(cb) {
    const wrap = cb.closest('.checkbox-upsell');
    if (wrap) wrap.classList.toggle('active', cb.checked);
  }
  currentVariantId() {
    return this.card && this.card.getAttribute('data-product-card-selected_variant_id');
  }
  checkedUpsellIds() {
    return this.upsells
      .filter((cb) => cb.checked)
      .map((cb) => cb.closest('[data-variant-id]'))
      .filter(Boolean)
      .map((el) => Number(el.dataset.variantId));
  }
  async add(e) {
    e.preventDefault();
    const id = Number(this.currentVariantId());
    if (!id) return;
    const btn = e.currentTarget;
    btn.classList.add('loading');
    const items = [{ id, quantity: Number(this.dataset.quantity || 1) }];
    this.checkedUpsellIds().forEach((uid) => items.push({ id: uid, quantity: 1 }));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('add failed');
      // Prestige cart drawer hooks (best effort) then fallback to cart page.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      const drawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); btn.classList.remove('loading'); }
      else window.location.href = '/cart';
    } catch (err) {
      btn.classList.remove('loading');
      window.location.href = '/cart';
    }
  }
}
if (!customElements.get('cart-form')) customElements.define('cart-form', KryoCartForm);
